var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    transform: "matrix(-1 0 0 1 22 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.55 7.12166L12.7915 6.36387L8.66012 10.4939C8.59353 10.56 8.54068 10.6387 8.50461 10.7254C8.46855 10.8121 8.44998 10.905 8.44998 10.9989C8.44998 11.0928 8.46855 11.1858 8.50461 11.2725C8.54068 11.3591 8.59353 11.4378 8.66012 11.504L12.7915 15.6361L13.5493 14.8783L9.67171 11L13.55 7.12166Z",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLeftArrow);
export default __webpack_public_path__ + "static/media/slider-left-arrow.b567bbd7a432fe92e5978c065d61dc9d.svg";
export { ForwardRef as ReactComponent };